import React from 'react'
import { Link } from '@inertiajs/react'
import { ArrowRight, Clock, Link2, Users } from 'lucide-react'
import { buttonVariants } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import type { MarketEmptyState as EmptyStateData, MarketStatus } from '@/types/market'

const ICON: Record<Exclude<MarketStatus, 'ready'>, React.ElementType> = {
  not_linked: Link2,
  no_compset: Users,
  no_data: Clock,
}

/** Replaces every section when the page has nothing to compare yet. Words and link from the server. */
export default function MarketEmptyState({
  status,
  emptyState,
}: {
  status: Exclude<MarketStatus, 'ready'>
  emptyState: EmptyStateData
}) {
  const Icon = ICON[status]
  return (
    <div
      data-testid={`market-empty-${status}`}
      className="animate-slide-in rounded-xl border border-dashed border-border bg-white p-10 text-center shadow-sm"
      style={{ animationDelay: '100ms' }}
    >
      <Icon className="mx-auto h-8 w-8 text-muted-foreground/40" />
      <p className="mt-3 text-sm font-medium text-foreground">{emptyState.headline}</p>
      <p className="mx-auto mt-1 max-w-md text-xs text-muted-foreground">{emptyState.body}</p>
      {emptyState.cta && (
        <Link href={emptyState.cta.href} className={cn(buttonVariants({ size: 'sm' }), 'mt-4 rounded-lg')}>
          {emptyState.cta.label}
          <ArrowRight className="ml-1.5 h-3.5 w-3.5" />
        </Link>
      )}
    </div>
  )
}
